import { Breadcrumbs } from "@mui/material";

export const MuiBreadcrumbs = Breadcrumbs;
